import React from 'react';
import { Label } from 'reactstrap';
import ReimbursementAmtElement from './ReimbursementAmtElement';
import DependentElement from './DependentElement';
import HRCodeListSelectElement from './HRCodeListSelectElement';
import InputElement from './InputElement';
import SelectElement from './SelectElement';
import PickListDetailsElement from './PickListDetailsElement';
import DateElement from './DateElement';

function AdditionDetailsModalElements({
  formMethods,
  name,
  type,
  config,
  rowData,
  formType,
  title,
  expenseClaimHeaders = null,
}) {
  let generatedElement = null;
  switch (type) {
    case 'reimbursementAmt':
      generatedElement = (
        <ReimbursementAmtElement
          formMethods={formMethods}
          name={name}
          rowData={rowData}
          formType={formType}
        />
      );
      break;
    case 'dependent':
      generatedElement = (
        <DependentElement
          formMethods={formMethods}
          name={name}
          codeType="DEPENDENT1"
          formType={formType}
          expenseClaimHeaders={expenseClaimHeaders}
        />
      );
      break;
    case 'dependentChild':
      generatedElement = (
        <DependentElement
          formMethods={formMethods}
          name={name}
          codeType="DEPENDENT"
          formType={formType}
          expenseClaimHeaders={expenseClaimHeaders}
        />
      );
      break;
    case 'entity':
      generatedElement = (
        <HRCodeListSelectElement
          formMethods={formMethods}
          name={name}
          type="COMPANY"
          cc="hrCd"
          formType={formType}
          title="Select the business entity under which the expense falls."
        />
      );
      break;
    case 'costAllocation':
      generatedElement = (
        <HRCodeListSelectElement
          formMethods={formMethods}
          name={name}
          type="EXPENSE_COST"
          cc="hrCd"
          formType={formType}
          title="Select how the cost should be allocated"
        />
      );
      break;
    case 'product':
      generatedElement = (
        <SelectElement
          formMethods={formMethods}
          name={name}
          options={[
            { value: 'ALL', label: 'ALL' },
            { value: 'APPL', label: 'APPL' },
            { value: 'DX', label: 'DX' },
            { value: 'VRV', label: 'VRV' },
          ]}
          formType={formType}
          title="Select product for the claim"
        />
      );
      break;
    case 'country':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="COUNTRY"
          config={config}
          formType={formType}
          title="Select country for the claim"
        />
      );
      break;
    case 'sorNo':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="SOR"
          config={config}
          formType={formType}
        />
      );
      break;
    case 'costCentre':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="CC"
          config={config}
          formType={formType}
        />
      );
      break;
    case 'costType':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="SERVICE_COST_TYPE"
          config={config}
          formType={formType}
        />
      );
      break;
    case 'sMan':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="GL_EMP"
          config={config}
          formType={formType}
        />
      );
      break;
    case 'orderNo':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="ORDERNO"
          config={config}
          formType={formType}
        />
      );
      break;
    case 'regionCode':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="Region"
          config={config}
          formType={formType}
        />
      );
      break;
    case 'reference':
      generatedElement = (
        <PickListDetailsElement
          formMethods={formMethods}
          name={name}
          type="Reference"
          config={config}
          formType={formType}
        />
      );
      break;
    case 'text':
      generatedElement = (
        <InputElement
          formMethods={formMethods}
          name={name}
          type="text"
          formType={formType}
          config={config}
        />
      );
      break;
    case 'number':
      generatedElement = (
        <InputElement
          formMethods={formMethods}
          name={name}
          type="number"
          formType={formType}
        />
      );
      break;
    case 'date':
      generatedElement = (
        <DateElement
          formMethods={formMethods}
          name={name}
          formType={formType}
          config={config}
        />
      );
      break;
    case 'textarea':
      generatedElement = (
        <InputElement
          formMethods={formMethods}
          name={name}
          type="textarea"
          formType={formType}
          title={title}
        />
      );
      break;
    default:
      generatedElement = <div>Unknown element type: {type}</div>;
  }
  return (
    <div>
      {config?.label && (
        <Label className="mb-0">
          {config.label}
          {config?.validation?.required && (
            <span
              style={{
                color: 'red',
                marginLeft: '2px',
                fontSize: '16px',
              }}
            >
              *
            </span>
          )}
        </Label>
      )}
      {generatedElement}
    </div>
  );
}

export default AdditionDetailsModalElements;
